import Card from "@ui-kit/data-display/Card/Card.web";
import Radio from "@ui-kit/form/Radio/Radio.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { useTranslation } from "@shared/utils/internationalization";
import { SeatOptionsRadioProps } from "./SeatOptionsRadio.props";

const SeatOptionsRadio = ({
  currentSeat,
  selectedSeat,
  updateSelectedSeat,
  index,
}: SeatOptionsRadioProps) => {
  const { t } = useTranslation("seating");

  return (
    <Card
      key={currentSeat.seatId}
      w="full"
      border="1px solid"
      borderColor="gray.400"
      rounded="sm"
    >
      <Radio
        size="lg"
        value={currentSeat.seatId}
        onChange={() => updateSelectedSeat(currentSeat)}
        isChecked={
          selectedSeat
            ? currentSeat.seatId === selectedSeat.seatId
            : index === 0
        }
      >
        <Text ml="xs" color="font.dark">
          <span>{t("Section")} </span>
          <strong>{currentSeat?.$data?.segment_identifier}</strong>
          <span>, {t("Row")} </span>
          <strong>{currentSeat?.$data?.location_identifier}</strong>
          <span>, {t("Seat")} </span>
          <strong>{currentSeat?.$data?.identifier}</strong>
        </Text>
      </Radio>
    </Card>
  );
};

export default SeatOptionsRadio;
